import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'emptyField',
})
export class EmptyFieldPipe implements PipeTransform {
  transform(value: AnyType, defaultValue = '--') {
    return value === undefined || value === null || (typeof value === 'string' && value.trim() === '')
      ? defaultValue
      : value;
  }
}
